import { render } from "./callout-comment.html?vue&type=template&id=9cfe29e4"
import script from "./CalloutComment.vue?vue&type=script&lang=ts"
export * from "./CalloutComment.vue?vue&type=script&lang=ts"

import "./callout-comment.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script